export const MESH_RECOMMENDATIONS =
  '      This role requires candidates with a high level of Accountability and Effort, along with strong Influencing and Conviction skills. Experience in the North America region and prior involvement in AI services projects are critical attributes that should be thoroughly assessed during interviews.';

export const MESH_RECOMMENDATIONS_RETIRE = {
  heading: 'Sibley Bourn & Yevgeniya Vinogradova are highly critical and at significant risk of leaving.',
  points: [
    'Sibley Bourn - As Engineering Manager, Sibley has driven several high-impact projects over the past three years, and her technical leadership is integral to the team’s success. Recently, however, there’s been a noticeable drop in engagement and fewer proactive efforts, impacting team morale and project timelines.',
    ' Yevgeniya Vinogradova - As Senior Account Manager, Yevgeniya has been essential to revenue growth, managing high-value accounts and maintaining client relationships. Recently, her involvement has lessened, with delayed client interactions, risking client satisfaction and account stability.',
  ],
};

export const MESH_RECOMMENDATIONS_PROGRESS = {
  heading: 'Some of your team member has performed well with high predicted goal and competency scores.',
  points: [
    'Marceau Rox has served in his current role for four years and has over seventeen years with the organisation. Given his high relevancy score, he may be well-suited for progression to the next role.',
    'Ming Ye has been in his current role for 3.5 years, with a tenure exceeding sixteen years at the organisation. With a high relevancy score, he could also be considered for advancement.',
  ],
};

export const MESH_RECOMMENDATIONS_ONBOARD = {
  heading:
    '      For Alex Spencer, a Junior Software Engineer, developing key skills is essential to advancing within the engineering team. Currently, Alex’s main growth areas include Team Collaboration, Advanced Test Case Development, Debugging and Troubleshooting, and Code Optimisation Techniques. Based on these needs, we recommend pairing Alex with mentors who excel in these specific areas. ',
  points: [
    'Bruce Salem covers all of Alex’s weaknesses as strengths, including Team Collaboration and Code Optimization Techniques. ',
    'Troy Carpenter brings strengths in Debugging and Troubleshooting, Documentation Skills, and Problem-Solving — three of Alex’s weaknesses as strengths.',
  ],
};

export const TABLE_COLUMNS_DISPLAYNAME = {
  APPLICANT_NAME: 'Applicant Name',
  TEAM_MEMBER_NAME: 'Team member name',
  AGE: 'Age',
  EXPERIENCE: 'Experience',
  OBJECTIVE_RELEVANCY_SCORE: 'Objective Relevancy Score',
  COMPETENCY_RELEVANCY_SCORE: 'Competency Relevancy Score',
  OVERALL_RELEVANCY_SCORE: 'Overall Relevancy Score',
  GENDER: 'Gender',
  TENURE: 'Tenure',
  DESIGNATION: 'Designation',
  LEVEL: 'Level',
  LOCATION: 'Location',
  MANAGER: 'Manager',
  ETHNICITY: 'Ethnicity',
  FUNCTION: 'Function',
  ROLE: 'Role',
  TIME_SPENT_IN_ROLE: 'Time spent in current role',
  EMPLOYEE_RELEVANCY_SCORE: 'Employee relevancy score',
  EMPLOYEE_RISK_SCORE: 'Employee risk score',
};

export const CANDIDATE_LIST_ROWS = [
  {
    '1': {
      value: 'Marceau Roux',
      imageUrl: 'https://media.mesh.ai/2415/media/profilePhoto/50705/2023/01/06/50705.jpg_1673027601109',
      email: 'marceau.roux@abc.co',
    },
    '2': {
      value: '32 years',
    },
    '3': {
      value: '2 years',
    },
    '4': {
      value: 'High (78%)',
    },
    '5': {
      value: 'Medium (63%)',
    },
    '6': {
      value: 'High (70.5%)',
    },
    '7': {
      value: 'Female',
    },
    '8': {
      value: '12 months',
    },
    '9': {
      value: 'Consultant',
    },
    '10': {
      value: 'S2',
    },
    '11': {
      value: 'Santa Clara',
    },
    '12': {
      value: 'Sibley Bourn',
    },
    '13': {
      value: 'Amerindian/Alaskan Native',
    },
    '14': {
      value: 'Product management',
    },
    '15': {
      value: 'Product manager',
    },
    '16': {
      value: '2 years',
    },
    '17': {
      value: 'Low (22.1)',
    },
    '18': {
      value: 'Medium (32.1)',
    },
  },
  {
    '1': {
      value: 'Jay Chandra',
      imageUrl: 'https://media.mesh.ai/2415/media/profilePhoto/50711/2023/01/06/50711.jpg_1673027596014',
      email: 'jay.chandra@abc.co',
    },
    '2': {
      value: '26 years',
    },
    '3': {
      value: '3.2 years',
    },
    '4': {
      value: 'Medium (60%)',
    },
    '5': {
      value: 'High (74%)',
    },
    '6': {
      value: 'High (67%)',
    },
    '7': {
      value: 'Male',
    },
    '8': {
      value: '6 months',
    },
    '9': {
      value: 'Consultant',
    },
    '10': {
      value: 'S2',
    },
    '11': {
      value: 'Gurgaon',
    },
    '12': {
      value: 'Sally Preston',
    },
    '13': {
      value: 'Asian',
    },
    '14': {
      value: 'Product management',
    },
    '15': {
      value: 'Product manager',
    },
    '16': {
      value: '5 years',
    },
    '17': {
      value: 'Medium (32.1)',
    },
    '18': {
      value: 'High (42.1)',
    },
  },
  {
    '1': {
      value: 'George Weber',
      imageUrl: 'https://media.mesh.ai/2415/media/profilePhoto/50720/2023/01/06/50720.jpg_1673027560850',
      email: 'george.weber@abc.co',
    },
    '2': {
      value: '33 years',
    },
    '3': {
      value: '10.5 years',
    },
    '4': {
      value: 'Medium (40%)',
    },
    '5': {
      value: 'Medium (42%)',
    },
    '6': {
      value: 'Medium (41%)',
    },
    '7': {
      value: 'Male',
    },
    '8': {
      value: '2.6 months',
    },
    '9': {
      value: 'Manager',
    },
    '10': {
      value: 'M3',
    },
    '11': {
      value: 'Bonn',
    },
    '12': {
      value: 'Mark Clarke',
    },
    '13': {
      value: 'Black',
    },
    '14': {
      value: 'Engineering',
    },
    '15': {
      value: 'Engineering manager',
    },
    '16': {
      value: '3 years',
    },
    '17': {
      value: 'Medium (32.1)',
    },
    '18': {
      value: 'Low (22.1)',
    },
  },
  {
    '1': {
      value: 'Ming Ye',
      imageUrl: 'https://media.mesh.ai/2415/media/profilePhoto/50718/2023/01/06/50718.jpg_1673027569324',
      email: 'ming.ye@abc.co',
    },
    '2': {
      value: '25 years',
    },
    '3': {
      value: '3 years',
    },
    '4': {
      value: 'High (83%)',
    },
    '5': {
      value: 'Low (21%)',
    },
    '6': {
      value: 'Medium (52%)',
    },
    '7': {
      value: 'Female',
    },
    '8': {
      value: '1.6 months',
    },
    '9': {
      value: 'Consultant',
    },
    '10': {
      value: 'L2',
    },
    '11': {
      value: 'Santa Clara',
    },
    '12': {
      value: 'Ged Frost',
    },
    '13': {
      value: 'Hawaiian Native',
    },
    '14': {
      value: 'Engineering',
    },
    '15': {
      value: 'Software engineer',
    },
    '16': {
      value: '3 years',
    },
    '17': {
      value: 'High (42.1)',
    },
    '18': {
      value: 'Medium (32.1)',
    },
  },
  {
    '1': {
      value: 'Hattie Cooper',
      imageUrl: 'https://media.mesh.ai/2415/media/profilePhoto/50702/2023/01/06/50702.jpg_1673027580262',
      email: 'hattie.cooper@abc.co',
    },
    '2': {
      value: '36 years',
    },
    '3': {
      value: '12.6 years',
    },
    '4': {
      value: 'Low (13%)',
    },
    '5': {
      value: 'Medium (42%)',
    },
    '6': {
      value: 'Low (25.5%)',
    },
    '7': {
      value: 'Female',
    },
    '8': {
      value: '9 months',
    },
    '9': {
      value: 'Consultant',
    },
    '10': {
      value: 'S3',
    },
    '11': {
      value: 'Chicago',
    },
    '12': {
      value: 'Ulric Clayton',
    },
    '13': {
      value: 'White',
    },
    '14': {
      value: 'Design',
    },
    '15': {
      value: 'UX designer',
    },
    '16': {
      value: '2 years',
    },
    '17': {
      value: 'Low (22.1)',
    },
    '18': {
      value: 'Medium (32.1)',
    },
  },
];

export const CANDIDATE_LIST_COLUMNS = [
  {
    displayName: 'Applicant Name',
    id: '1',
  },
  {
    displayName: 'Overall Relevancy Score',
    id: '6',
  },
  {
    displayName: 'Objective Relevancy Score',
    id: '4',
  },
  {
    displayName: 'Competency Relevancy Score',
    id: '5',
  },
  {
    displayName: 'Tenure',
    id: '8',
  },
  {
    displayName: 'Designation',
    id: '9',
  },
  {
    displayName: 'Age',
    id: '2',
  },
  // {
  //   displayName: 'Experience',
  //   id: '3',
  // },
  {
    displayName: 'Gender',
    id: '7',
  },
  // {
  //   displayName: 'Level',
  //   id: '10',
  // },
  {
    displayName: 'Location',
    id: '11',
  },
  // {
  //   displayName: 'Manager',
  //   id: '12',
  // },
  {
    displayName: 'Ethnicity',
    id: '13',
  },
];

export const MOCK_SPIDER_CHART_DATA = {
  maxRating: 100,
  competencyDetails: [
    {
      competencyId: 206997,
      competencyName: 'Influence & conviction',
    },
    {
      competencyId: 206998,
      competencyName: 'Drive & competitiveness',
    },
    {
      competencyId: 206999,
      competencyName: 'Learning & application',
    },
    {
      competencyId: 207000,
      competencyName: 'Accountability &effort',
    },
    {
      competencyId: 207001,
      competencyName: 'Insights & analysis',
    },
  ],
  competencyGraphData: [
    {
      employeeId: null,
      nodeType: 'COMPANY',
      employeeProfile: null,
      scores: [
        {
          competencyId: 206997,
          score: 95,
        },
        {
          competencyId: 206998,
          score: 85,
        },
        {
          competencyId: 206999,
          score: 85,
        },
        {
          competencyId: 207000,
          score: 99.4,
        },
        {
          competencyId: 207001,
          score: 70.2,
        },
      ],
    },
  ],
};

export const WORD_CLOUD_WORDS = [
  {
    text: 'Sales',
    value: 10,
  },
  {
    text: 'Strategy',
    value: 20,
  },
  {
    text: 'B2B Sales',
    value: 40,
  },
  {
    text: 'CRM Enterprise',
    value: 30,
  },
  {
    text: 'Salesforce',
    value: 20,
  },
  {
    text: 'MBA',
    value: 35,
  },
  {
    text: 'SaaS',
    value: 68,
  },
  {
    text: 'Enterprise clients',
    value: 79,
  },
  {
    text: 'North America',
    value: 60,
  },
  {
    text: 'AI Knowledge',
    value: 80,
  },
  {
    text: 'North America',
    value: 77,
  },
  {
    text: 'Revenue generation',
    value: 66,
  },
  {
    text: 'Negotiations',
    value: 55,
  },
  {
    text: 'Linkedin Sales',
    value: 44,
  },
  {
    text: 'AI Services',
    value: 69,
  },
  {
    text: 'AI Knowledge',
    value: 82,
  },
  {
    text: '8-12 years work exp.',
    value: 44,
  },
];

export const MOCK_LINE_CHART_DATA = {
  nodes: [
    {
      id: '12',
      name: 'Historical turnover',
      color: {
        dark: '#44812F',
        light: '#44812F ',
      },
    },
    {
      id: '21',
      name: 'Voluntary rates',
      color: {
        dark: '#B96400',
        light: '#B96400',
      },
    },
  ],
  yaxisRange: {
    start: 0,
    end: 120,
  },
  xaxis: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
  series: [
    {
      id: '12',
      data: [80, 45, 54, 40, 78, 70],
    },
    {
      id: '21',
      data: [20, 18, 15, 20, 22, 28],
    },
  ],
};

export const TABLE_COLUMNS_DISPLAYNAME_RETIRE = {
  EMPLOYEE_NAME: 'Employee Name',
  ATTRITION: 'Attrition Likelihood (Score)',
  EMPLOYEE_CRITICALITY_SCORE: 'Criticality to Organisation (Score)',
  GENDER: 'Gender',
  AGE: 'Age',
  TOTAL_EXPERIENCE: 'Total experience',
  FUNCTION: 'Function',
  ROLE: 'Role',
  TIME_SPENT_IN_ROLE: 'Time spent in current role',
};

export const RETIRE_TABLE_COLUMNS = [
  {
    displayName: 'Employee Name',
    id: '1',
  },
  {
    displayName: 'Attrition Likelihood (Score)',
    id: '2',
  },
  {
    displayName: 'Criticality to Organisation (Score)',
    id: '3',
  },

  {
    displayName: 'Function',
    id: '7',
  },
  {
    displayName: 'Role',
    id: '8',
  },
  {
    displayName: 'Time spent in current role',
    id: '9',
  },
  {
    displayName: 'Total experience',
    id: '6',
  },
];

export const RETIRE_TABLE_ROWS = [
  {
    '1': {
      value: {
        name: 'Sibley Bourn',
        email: 'sibley.bourn@abc.co',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50695/2023/01/06/50695.jpg_1673027621626',
      },
    },
    '2': { value: 'High (90%)' },
    '3': { value: 'High (84%)' },
    '4': { value: 'Female' },
    '5': { value: '29' },
    '6': { value: '6 years' },
    '7': { value: 'Engineering' },
    '8': { value: 'Engineering Manager' },
    '9': { value: '3 years' },
  },
  {
    '1': {
      value: {
        name: 'Yevgeniya Vinogradova',
        email: 'yevgeniya.vinogradova@abc.co',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50707/2023/01/06/50707.jpg_1673027634925',
      },
    },
    '2': { value: 'High (84%)' },
    '3': { value: 'High (94%)' },
    '4': { value: 'Female' },
    '5': { value: '32' },
    '6': { value: '9 years' },
    '7': { value: 'Sales' },
    '8': { value: 'Senior Account Manager' },
    '9': { value: '2 years' },
  },
  {
    '1': {
      value: {
        name: 'Nikhil Bhat',
        email: 'nikhil.bhat@abc.co',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50703/2023/01/06/50703.jpg_1673027608662',
      },
    },
    '2': { value: 'Medium (60%)' },
    '3': { value: 'Low (36%)' },
    '4': { value: 'Male' },
    '5': { value: '34' },
    '6': { value: '10 years' },
    '7': { value: 'Product' },
    '8': { value: 'Senior Product Manager' },
    '9': { value: '5 years' },
  },
  {
    '1': {
      value: {
        name: 'Carlos Jiron',
        email: 'carlos.jiron@abc.co',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50700/2023/01/06/50700.jpg_1673027566718',
      },
    },
    '2': { value: 'Low (32%)' },
    '3': { value: 'High (94%)' },
    '4': { value: 'Male' },
    '5': { value: '38' },
    '6': { value: '15 years' },
    '7': { value: 'Sales' },
    '8': { value: 'Head of Sales' },
    '9': { value: '6 months' },
  },
  {
    '1': {
      value: {
        name: 'Chloe Nunez',
        email: 'chloe.nunez@abc.co',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50721/2023/01/06/50721.jpg_1673027588228',
      },
    },
    '2': { value: 'Medium (56%)' },
    '3': { value: 'Low (30%)' },
    '4': { value: 'Female' },
    '5': { value: '30' },
    '6': { value: '6 years' },
    '7': { value: 'Engineering' },
    '8': { value: 'iOS Developer' },
    '9': { value: '1 year' },
  },
  {
    '1': {
      value: {
        name: 'Dai Long',
        email: 'dai.long@abc.co',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50715/2023/01/06/50715.jpg_1673027571813',
      },
    },
    '2': { value: 'Low (34%)' },
    '3': { value: 'Low (36%)' },
    '4': { value: 'Male' },
    '5': { value: '28' },
    '6': { value: '4 years' },
    '7': { value: 'People & Culture' },
    '8': { value: 'HR Analyst' },
    '9': { value: '4 years' },
  },
  {
    '1': {
      value: {
        name: 'Ged Frost',
        email: 'ged.frost@abc.co',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50709/2023/01/06/50709.jpg_1673027575066',
      },
    },
    '2': { value: 'Low (24%)' },
    '3': { value: 'Medium (68%)' },
    '4': { value: 'Male' },
    '5': { value: '33' },
    '6': { value: '8 years' },
    '7': { value: 'Sales' },
    '8': { value: 'SDR Manager' },
    '9': { value: '3 years' },
  },
  {
    '1': {
      value: {
        name: 'Giulia Mancini',
        email: 'giulia.mancini@abc.co',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50714/2023/01/06/50714.jpg_1673027577544',
      },
    },
    '2': { value: 'Low (26%)' },
    '3': { value: 'Low (24%)' },
    '4': { value: 'Female' },
    '5': { value: '24' },
    '6': { value: '2 years' },
    '7': { value: 'Product' },
    '8': { value: 'Product Analyst' },
    '9': { value: '1 year' },
  },
  {
    '1': {
      value: {
        name: 'Hattie Cooper',
        email: 'hattie.cooper@abc.co',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50702/2023/01/06/50702.jpg_1673027580262',
      },
    },
    '2': { value: 'Low (20%)' },
    '3': { value: 'High (96%)' },
    '4': { value: 'Female' },
    '5': { value: '45' },
    '6': { value: '17 years' },
    '7': { value: 'Engineering' },
    '8': { value: 'VP Engineering / Director Engineering' },
    '9': { value: '4 years' },
  },
  {
    '1': {
      value: {
        name: 'George Weber',
        email: 'george.weber@abc.co',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50720/2023/01/06/50720.jpg_1673027560850',
      },
    },
    '2': { value: 'Medium (58%)' },
    '3': { value: 'Medium (72%)' },
    '4': { value: 'Male' },
    '5': { value: '43' },
    '6': { value: '17 years' },
    '7': { value: 'People & Culture' },
    '8': { value: 'People and Culture Executive' },
    '9': { value: '4.5 years' },
  },
];

export const TABLE_COLUMNS_DISPLAYNAME_PROGRESS = {
  NAME: 'Name',
  PREDICTED_GOAL_SCORE: 'Predicted Goal Score',
  PREDICTED_COMPETENCY_SCORE: 'Predicted Competency Score',
  PREDICTED_CONFIDENCE_SCORE: 'Promotion confidence score',
  EXPERIENCE_IN_CURRENT_ROLE: 'Experience in current role',
  TENURE: 'Tenure',
  TOTAL_EXPERIENCE: 'Total experience',
};

export const LIFECYCLE_INSIGHTS_PROGRESS_TABLE_COLUMNS = [
  {
    displayName: TABLE_COLUMNS_DISPLAYNAME_PROGRESS.NAME,
    id: '1',
  },
  {
    displayName: TABLE_COLUMNS_DISPLAYNAME_PROGRESS.PREDICTED_GOAL_SCORE,
    id: '2',
  },
  {
    displayName: TABLE_COLUMNS_DISPLAYNAME_PROGRESS.PREDICTED_COMPETENCY_SCORE,
    id: '3',
  },
  {
    displayName: TABLE_COLUMNS_DISPLAYNAME_PROGRESS.PREDICTED_CONFIDENCE_SCORE,
    id: '4',
  },
  {
    displayName: TABLE_COLUMNS_DISPLAYNAME_PROGRESS.EXPERIENCE_IN_CURRENT_ROLE,
    id: '5',
  },

  {
    displayName: TABLE_COLUMNS_DISPLAYNAME_PROGRESS.TENURE,
    id: '6',
  },
  {
    displayName: TABLE_COLUMNS_DISPLAYNAME_PROGRESS.TOTAL_EXPERIENCE,
    id: '7',
  },
];

export const LIFECYCLE_INSIGHTS_PROGRESS_TABLE_ROWS = [
  {
    '1': {
      value: {
        name: 'Marceau Roux',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50705/2023/01/06/50705.jpg_1673027601109',
        email: 'marceau.roux@abc.co',
      },
    },
    '2': { value: 'High (81%)' },
    '3': { value: 'High (71%)' },
    '4': { value: 'High (78%)' },
    '5': { value: '4 years' },
    '6': { value: '4 years' },
    '7': { value: '17 years' },
  },
  {
    '1': {
      value: {
        name: 'Ming Ye',
        email: 'ming.ye@abc.co',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50718/2023/01/06/50718.jpg_1673027569324',
      },
    },
    '2': { value: 'High (81%)' },
    '3': { value: 'Low (48%)' },
    '4': { value: 'High (73%)' },
    '5': { value: '3.5 years' },
    '6': { value: '17 years' },
    '7': { value: '7 years' },
  },
  {
    '1': {
      value: {
        name: 'Jay Chandra',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50711/2023/01/06/50711.jpg_1673027596014',
        email: 'jay.chandra@abc.com',
      },
    },
    '2': { value: 'Low (42%)' },
    '3': { value: 'High (81%)' },
    '4': { value: 'Medium (60%)' },
    '5': { value: '2.5 years' },
    '6': { value: '2.5 years' },
    '7': { value: '10 years' },
  },
  {
    '1': {
      value: {
        name: 'George Weber',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50720/2023/01/06/50720.jpg_1673027560850',
        email: 'george.weber@abc.co',
      },
    },
    '2': { value: 'Low (38%)' },
    '3': { value: 'Low (48%)' },
    '4': { value: 'Medium (40%)' },
    '5': { value: '2 years' },
    '6': { value: '6 years' },
    '7': { value: '10 years' },
  },
  {
    '1': {
      value: {
        name: 'Hattie Cooper',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50702/2023/01/06/50702.jpg_1673027580262',
        email: 'hattie.cooper@abc.co',
      },
    },
    '2': { value: 'Low (12%)' },
    '3': { value: 'Low (32%)' },
    '4': { value: 'Low (13%)' },
    '5': { value: '2 years' },
    '6': { value: '10 years' },
    '7': { value: '18 years' },
  },
];

export const WORD_CLOUD_WORDS_ONBOARD = [
  { value: 20, text: 'Code quality', color: '#008000' },
  { value: 19, text: 'Team collaboration', color: '#FFA500' },
  { value: 18, text: 'Understanding of requirements', color: '#008000' },
  { value: 15, text: 'Code velocity', color: '#008000' },
  { value: 14, text: 'Advanced test case development', color: '#FFA500' },
  { value: 12, text: 'Basic test case writing', color: '#008000' },
  { value: 11, text: 'Debugging and troubleshooting', color: '#FFA500' },
  { value: 10, text: 'Code readability', color: '#008000' },
  { value: 8, text: 'Documentation skills', color: '#008000' },
  { value: 7, text: 'Code optimisation techniques', color: '#FFA500' },
];

export const TABLE_COLUMNS_DISPLAYNAME_ONBOARD = {
  EMPLOYEE_NAME: 'Name',
  MENTOR_NAME: 'Mentor name',
  NUMBER_OF_MENTEES: 'No. of mentees',
  SKILLS: 'Skills',
  MENTOR_MATCH: 'Mentor match',
  FUNCTION: 'Function',
  ROLE: 'Role',
};

export const TABLE_COLUMNS_ONBOARD = [
  {
    displayName: 'Mentor name',
    id: '1',
  },
  {
    displayName: TABLE_COLUMNS_DISPLAYNAME_ONBOARD.NUMBER_OF_MENTEES,
    id: '2',
  },
  {
    displayName: 'Skills',
    id: '3',
  },
  {
    displayName: 'Mentor match',
    id: '4',
  },
  {
    displayName: 'Function',
    id: '5',
  },
  {
    displayName: 'Role',
    id: '6',
  },
];

export const TABLE_ROWS_ONBOARD = [
  {
    '1': {
      value: {
        name: 'Bruce Salem',
        email: 'bruce.salem@abc.co',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50724/2023/01/06/50724.jpg_1673027627036',
      },
    },
    '2': { value: 5 },
    '3': {
      value: [
        { name: 'Code quality', color: '#008000', label: 'Strength' },
        { name: 'Team collaboration', color: '#008000', label: 'Strength' },
        { name: 'Documentation', color: '#008000', label: 'Strength' },
        {
          name: 'Advanced test case development',
          color: '#008000',
          label: 'Strength',
        },
        {
          name: 'Debugging and troubleshooting',
          color: '#008000',
          label: 'Strength',
        },
        {
          name: 'Code optimisation techniques',
          color: '#008000',
          label: 'Strength',
        },
        { name: 'Code velocity', color: '#008000', label: 'Strength' },
        { name: 'Efficiency in coding', color: '#008000', label: 'Strength' },
        { name: 'Test-driven development', color: '#0000FF', label: 'Neutral' },
        { name: 'Understanding of PRDs', color: '#008000', label: 'Strength' },
      ],
    },
    '4': { value: 'High (95%)' },
    '5': { value: 'Engineering' },
    '6': { value: 'Backend Engineer' },
  },
  {
    '1': {
      value: {
        name: 'Troy Carpenter',
        email: 'troy.carpenter@abc.co',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50712/2023/01/06/50712.jpg_1673027629546',
      },
    },
    '2': { value: 3 },
    '3': {
      value: [
        { name: 'Code velocity', color: '#008000', label: 'Strength' },
        {
          name: 'Debugging and troubleshooting',
          color: '#008000',
          label: 'Strength',
        },
        { name: 'Documentation skills', color: '#0000FF', label: 'Neutral' },
        { name: 'Code readability', color: '#008000', label: 'Strength' },
        {
          name: 'Basic test case writing',
          color: '#008000',
          label: 'Strength',
        },
        { name: 'Team collaboration', color: '#0000FF', label: 'Neutral' },
        {
          name: 'Time management in coding',
          color: '#FFA500',
          label: 'Weakness',
        },
        { name: 'Problem-solving', color: '#008000', label: 'Strength' },
        { name: 'Attention to detail', color: '#0000FF', label: 'Neutral' },
        { name: 'Understanding of PRDs', color: '#0000FF', label: 'Neutral' },
      ],
    },
    '4': { value: 'Medium (75%)' },
    '5': { value: 'Engineering' },
    '6': { value: 'Software Architect' },
  },
  {
    '1': {
      value: {
        name: 'Chloe Nunez',
        email: 'chloe.nunez@abc.co',
        profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50721/2023/01/06/50721.jpg_1673027588228',
      },
    },
    '2': { value: 2 },
    '3': {
      value: [
        { name: 'Problem-solving', color: '#008000', label: 'Strength' },
        { name: 'Debugging', color: '#008000', label: 'Strength' },
        { name: 'Code readability', color: '#0000FF', label: 'Neutral' },
        { name: 'Documentation skills', color: '#008000', label: 'Strength' },
        {
          name: 'Code optimisation techniques',
          color: '#FFA500',
          label: 'Weakness',
        },
        { name: 'Advanced debugging', color: '#008000', label: 'Strength' },
        {
          name: 'Test-driven development',
          color: '#008000',
          label: 'Strength',
        },
        { name: 'Code velocity', color: '#0000FF', label: 'Neutral' },
        {
          name: 'Basic algorithm knowledge',
          color: '#008000',
          label: 'Strength',
        },
        { name: 'Attention to detail', color: '#0000FF', label: 'Neutral' },
      ],
    },
    '4': { value: 'Low (20%)' },
    '5': { value: 'Engineering' },
    '6': { value: 'Backend Engineer' },
  },
];
